import moment from 'moment'

import isOneHourBefore from '../helpers/is_one_hour_before'

import formatShortDay from './short_day'
import formatShortTimeOfDay from './short_time_of_day'

export default (time) => {
  if (!time) return ''
  if (!isOneHourBefore(time)) return ''

  time = moment(time)
  const now = moment()
  const oneHourBefore = moment(now).subtract(1, 'hour')
  const oneDayBefore = moment(now).subtract(1, 'day')

  if (time.isBefore(oneDayBefore)) return formatShortDay(time)
  if (time.isBefore(oneHourBefore)) return formatShortTimeOfDay(time)

  return time.to(now)
}



/** WEBPACK FOOTER **
 ** ./modules/shared/data/formatters/message_time.js
 **/